<template>
    <div class="radio-input-wrapper">
        <div class="radio-group flex flex-col">
            <label 
                v-for="option in field.options" 
                :key="option.id" 
                class="radio-container flex items-center mb-2"
                :class="{ 'radio-disabled': !enabled, 'radio-selected': internalValue === option.value }"
            >
                <input 
                    type="radio" 
                    :id="`option-${option.id}${idSuffix}`" 
                    :value="option.value" 
                    v-model="internalValue"
                    :disabled="!enabled" 
                    :required="field.required" 
                    class="radio-native w-5 h-5 mr-2"
                    :class="{ 'input-error': display_errors && error }"
                    @change="$emit('update:value', internalValue); $emit('validate')"
                    :aria-invalid="display_errors && error ? 'true' : 'false'" 
                    :aria-describedby="errorId" 
                />
                <span class="radio-custom">
                    <span class="radio-dot"></span>
                </span>
                <span class="radio-content flex items-center">
                    <span class="radio-label text-base text-[var(--tone-gray)]">{{ option.label }}</span>
                    <span v-if="option.additional_fee && option.price" class="price-badge bg-[var(--light-beige)] text-[var(--dark-brownish-gray)] text-sm font-semibold px-2 py-0.5 rounded-full flex items-center ml-2">
                        $ {{ option.price }}{{ perPersonSuffix }}
                    </span>
                </span>
            </label>
        </div>
        <div v-if="display_errors && error" class="error-message flex items-center text-sm text-[var(--error)]" :id="errorId">
            <svg class="max-w-full mr-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: { type: Object, required: true },
        value: { type: [String, null], default: null },
        enabled: { type: Boolean, default: true },
        display_errors: { type: Boolean, default: false },
        error: { type: String, default: '' },
        idSuffix: { type: String, default: '' }
    },
    computed: {
        errorId() { return `error-field-${this.field.id}${this.idSuffix}`; },
        // display_once price_per_pax fields are answered once but priced per
        // traveler — flag that next to the price so it's not mistaken for a flat fee.
        perPersonSuffix() {
            return (this.field.unit_type === 'price_per_pax' && !!this.field.display_once) ? '/person' : '';
        },
        internalValue: {
            get() { return this.value; },
            set(newValue) { this.$emit('update:value', newValue); }
        }
    }
};
</script>
